import React, { useEffect, useState } from 'react';
import { Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { pickPageName } from '../../../../utils/dataPortalCache';
import { DataPortalPageType } from '../graphql/queries';

interface Props {
    open: boolean;
    page: DataPortalPageType | null;
    onCancel: () => void;
    onConfirm: () => void;
}

/**
 * 删除看板确认弹窗。
 *
 * 要求**输入看板名称完全一致**才能删：配置本身无法恢复（只能靠操作流水人工填回），
 * 而删掉会让所有可见人员的二级栏里少一项，代价远高于误删一个分组。
 */
const DeleteBoardModal: React.FC<Props> = ({ open, page, onCancel, onConfirm }) => {
    const { t, i18n } = useTranslation();
    const [input, setInput] = useState('');

    useEffect(() => {
        if (open) setInput('');
    }, [open, page?.id]);

    if (!page) return null;

    const name = pickPageName(page, i18n.language);
    const viewerCount =
        page.visibleScope === 'ACCOUNT' ? page.visibleAccounts.length : page.visibleRoles.length;

    return (
        <Modal
            open={open}
            title={t('central.dataPortalConfig.messages.deleteConfirm')}
            onCancel={onCancel}
            onOk={onConfirm}
            okText={t('components.button.delete') as string}
            cancelText={t('components.button.cancel') as string}
            okButtonProps={{ danger: true, disabled: input.trim() !== name }}
            destroyOnClose
        >
            <div className="mb-3 text-sm">
                {t('central.dataPortalConfig.messages.deleteBoardTip', { name, count: viewerCount })}
            </div>
            <Input
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder={t('central.dataPortalConfig.placeholders.confirmBoardName') as string}
            />
        </Modal>
    );
};

export default DeleteBoardModal;
